import { PrivateAssetUploader } from "./asset-uploader";
import { compose, setDisplayName, withProps } from 'react-recompose';
import { removeProps } from "../hoc";
var MediaAssetUploader = compose(setDisplayName('MediaAssetUploader'), withProps({
  showUploadButton: true,
  showSelectButton: true
}))(PrivateAssetUploader);
export default MediaAssetUploader;
//# sourceMappingURL=media-asset-uploader.js.map